import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <Header />
        <div className="cart-page__empty">
          <h2>Your cart is empty</h2>
          <p>Explore our collection of fine teas and ceramics!</p>
          <Link to="/shop" onClick={toTop} className="cart-page__continue-btn">
            Continue shopping
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="cart-page">
      <Header />

      <div className="cart-page__container">
        <h1 className="cart-title">Your Bag ({cartItems.length})</h1>

        <div className="cart-grid">
          <div className="cart-items">
            <div className="cart-delivery-note">
              Delivered by <strong>Boventraix</strong>
            </div>

            {cartItems.map((item) => {
              const product = getProductById(item.id);
              if (!product) return null;
              const price = parseFloat(product.price.replace(/,/g, ""));
              return (
                <div
                  className="cart-item"
                  key={`${item.id}-${item.size}-${item.color}`}
                >
                  <button
                    className="remove-btn"
                    onClick={() =>
                      removeFromCart(item.id, item.size, item.color)
                    }
                    aria-label="Remove"
                  >
                    🗑
                  </button>
                  <img
                    className="cart-thumb"
                    src={product.image}
                    alt={product.name}
                  />
                  <div className="cart-info">
                    <div className="cart-brand">Boventraix</div>
                    <div className="cart-name">{product.name}</div>
                    <div className="cart-price">
                      £{price.toFixed(2)}{" "}
                      <span className="cart-old">
                        £{(price * 1.2).toFixed(2)}
                      </span>
                    </div>
                    <div className="cart-opts">
                      <div>
                        Size: <strong>{item.size}</strong>
                      </div>
                      <div>
                        Colour: <strong>{item.color}</strong>
                      </div>
                    </div>
                    <div className="qty-row">
                      <label>Quantity:</label>
                      <div className="qty-controls">
                        <button
                          onClick={() =>
                            handleUpdateQuantity(
                              item.id,
                              item.size,
                              item.color,
                              item.quantity - 1
                            )
                          }
                        >
                          -
                        </button>
                        <div className="qty-num">{item.quantity}</div>
                        <button
                          onClick={() =>
                            handleUpdateQuantity(
                              item.id,
                              item.size,
                              item.color,
                              item.quantity + 1
                            )
                          }
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            <div className="upsell">
              <h3>A little something extra?</h3>
              <div className="upsell-grid">
                {productData.slice(0, 5).map((p) => (
                  <Link
                    onClick={toTop}
                    key={p.id}
                    to={`/shopDetails/${p.id}`}
                    className="upsell-card"
                  >
                    <img src={p.image} alt={p.name} />
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <aside className="order-summary">
            <h3>Order Summary</h3>
            <div className="summary-row">
              <div>Subtotal</div>
              <div>£{subtotal.toFixed(2)}</div>
            </div>
            <div className="summary-row">
              <div>Discount</div>
              <div>-£{(subtotal * 0.25).toFixed(2)}</div>
            </div>
            <div className="summary-total">
              <div>Order total</div>
              <div>£{(subtotal * 0.75).toFixed(2)}</div>
            </div>

            <button className="checkout-btn" onClick={handleCheckout}>
              CHECKOUT
            </button>
          </aside>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CartPage;
